module.exports = __webpack_public_path__ + "fonts/df1df280a9204052803846e1b5df5e92.svg";